import { mapActions, mapGetters } from "vuex";

const CHILD_BROADCAST_SIGNAL = 2;

export default {
  computed: {
    ...mapGetters("broadcast", ["broadcastActionList"],),
    ...mapGetters("taskSummaryData", ["taskSummaryDataLoadingStatusBackground"],)
  },
  methods: {
    ...mapActions({
      removeBroadcastAction: "broadcast/removeBroadcastAction",
    }),
    scGuidanceBroadcastHandler(payload) {
      this.broadcastScTaskAggChange(payload);
      this.broadcastGuidanceSessChange(payload);
      this.broadcastScTaskListChange(payload);
    },
    scAdjustmentBroadcastHandler(payload) {
      this.broadcastScCallListChange(payload);
      this.broadcastScCallTaskListChange(payload);
    },
    taskSummaryBroadcastHandler() {
      this.broadcastTaskSummChange();
      this.broadcastTaskSummScChange();
    },
    taskSummaryBroadcastDateRangeHandler() {
      this.broadcastTaskSummDateRangeChange();
    },
    taskAgentSummBroadcastHandler(payload) {
      this.broadcastGuidanceSessChange(payload);
      this.broadcastTaskSummListChange(payload);
    },
    broadcastTaskSummListChange(payload) {
      let broadcastAction = this.findBroadcastAction(
        process.env.VUE_APP_BROADCAST_TASK_SUMM_LIST_DATA
      );

      if (broadcastAction) {
        payload.loadingMask = false;
        this.retrieveTaskList(payload);
      }
      this.spliceBroadcastAction(broadcastAction);
    },

    findBroadcastAction(action) {
      return this.broadcastActionList.find(
        broadcast =>
          broadcast.action == action &&
          broadcast.signal == CHILD_BROADCAST_SIGNAL
      );
    },
    broadcastScCallListChange(payload) {
      let broadcastAction = this.findBroadcastAction(
        process.env.VUE_APP_BROADCAST_SC_ADJUSTMENT_DATA
      );

      if (broadcastAction) {
        payload.loadingMask = false;
        this.retrieveAllCallScorecardDataV2(payload);
      }

      this.spliceBroadcastAction(broadcastAction);
    },
    broadcastScCallTaskListChange(payload) {
      let broadcastAction = this.findBroadcastAction(
        process.env.VUE_APP_BROADCAST_SC_CALL_TASK_LIST_DATA
      );

      if (broadcastAction) {
        payload.loadingMask = false;
        this.retrieveScorecardTaskList(payload);
      }

      this.spliceBroadcastAction(broadcastAction);
    },
    broadcastTaskSummChange() {
      let broadcastAction = this.findBroadcastAction(
        process.env.VUE_APP_BROADCAST_TASK_SUMMARY_DATA
      );
      if (
        this.taskSummaryDataLoadingStatusBackground != "loading" &&
        this.preloadDataReady &&
        broadcastAction
      ) {
        this.reloadData(false);
      }
      this.spliceBroadcastAction(broadcastAction);
    },
    broadcastTaskSummScChange() {
      let broadcastAction = this.findBroadcastAction(
        process.env.VUE_APP_BROADCAST_SC_ADJUSTMENT_DATA
      );
      
      if (
        this.taskSummaryDataLoadingStatusBackground != "loading" &&
        this.preloadDataReady &&
        broadcastAction
      ) {
        this.reloadData(false);
      }
      this.spliceBroadcastAction(broadcastAction);
    },
    broadcastTaskSummDateRangeChange() {
      let broadcastAction = this.findBroadcastAction(
        process.env.VUE_APP_BROADCAST_SET_FIX_DATE_RANGE
      );
      if (broadcastAction) {
        this.$store.dispatch('taskSummaryData/setFixDateRange', broadcastAction.payload.payload);
      }
      this.spliceBroadcastAction(broadcastAction);
    },
    broadcastScTaskAggChange(payload) {
      let broadcastAction = this.findBroadcastAction(
        process.env.VUE_APP_BROADCAST_SC_GUIDANCE_DATA
      );

      if (this.scorecardScope && broadcastAction) {
        this.retrieveScorecardTaskAggregateData(payload);
      }

      this.spliceBroadcastAction(broadcastAction);
    },
    broadcastScTaskListChange(payload) {
      let broadcastAction = this.findBroadcastAction(
        process.env.VUE_APP_BROADCAST_SC_TASK_LIST_DATA
      );

      if (this.scorecardScope && broadcastAction) {
        payload.loadingMask = false;
        this.retrieveGuidanceTaskList(payload);
      }

      this.spliceBroadcastAction(broadcastAction);
    },
    broadcastGuidanceSessChange(payload) {
      let broadcastAction = this.findBroadcastAction(
        process.env.VUE_APP_BROADCAST_GUIDANCE_SESSION_DATA
      );

      if (broadcastAction) {
        this.retrieveGuidanceSessionList(payload);
      }

      this.spliceBroadcastAction(broadcastAction);
    },

    spliceBroadcastAction(broadcastAction) {
      //WARNING: individual component handlers should always remove the action from the list once they are finished...

      if (broadcastAction) {
        this.removeBroadcastAction(broadcastAction);
      }
    }
  }
};
